import React from 'react';
import ShowIconShowingIfUserHasAccessToModule
    from "../../../../../components/customBreachBits/info/IconShowingIfCustomerHasAccessToModule";
import CIRTContinuousControlWidget
    from "../../../../../components/customBreachBits/controllers/CIRTControlButton/CIRTContinuousControlWidget";

const YourCIRTModulesWidgetPane = ({isStaffAdmin, customer = null,}) => {
    return(
        <>
            <h2>Your CIRT™ Modules</h2>
            <p>CIRT™ provides continuous, affordable penetration testing with advanced flexibility and control. CIRT™ Modules provide specific functionality built in to your company's purchase agreement or subscription.</p>


            <ShowIconShowingIfUserHasAccessToModule module={"monitor"}/>
            <ShowIconShowingIfUserHasAccessToModule module={"perimeter"}/>
            <ShowIconShowingIfUserHasAccessToModule module={"insider"}/>
            <ShowIconShowingIfUserHasAccessToModule module={"social"}/>
            <ShowIconShowingIfUserHasAccessToModule module={"cmmc"}/>
            {isStaffAdmin && <ShowIconShowingIfUserHasAccessToModule module={"nist-171"}/>}
           <br/>
            <h4>Continuous Perimeter Attacks</h4>
            <p>The CIRT™ Perimeter module is controlled by this control setting.  When this control is disabled, no active attacks will occur.  Reconnaissance and low-level activity will continue.</p>
            <CIRTContinuousControlWidget customerId={customer.CustomerId} overrideEnabledForAdminsStaff={isStaffAdmin}/>

        </>
    )
}

export default YourCIRTModulesWidgetPane;